import classnames from 'classnames'
import React, { MouseEventHandler } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { IRootState } from '@/modules'
import { appSelector } from '@/modules/common/app'
import { IYearMonthInfo } from '@/utils/bridgeUtils/features/getYearMonth'
import { getMonthName } from '@/utils/dateUtils'
import { getFormattedYearMonth } from '@/utils/formatUtils'

interface IMonthTitleProps {
  date: IYearMonthInfo
  onClick: MouseEventHandler<HTMLSpanElement>
}

export const MonthTitle = (props: IMonthTitleProps) => {
  const { date } = props
  const formattedYearMonth = getFormattedYearMonth(date.year, date.month, '-')
  const isID = useSelector<IRootState, any>(appSelector.isID, shallowEqual)
  let monthName = getMonthName(new Date(formattedYearMonth), 'MMMM')

  if (isID === 'id_ID') {
    if (monthName === 'January') {
      monthName = 'Januari'
    } else if (monthName === 'February') {
      monthName = 'Februari'
    } else if (monthName === 'March') {
      monthName = 'Maret'
    } else if (monthName === 'April') {
      monthName = 'April'
    } else if (monthName === 'May') {
      monthName = 'Mei'
    } else if (monthName === 'June') {
      monthName = 'Juni'
    } else if (monthName === 'July') {
      monthName = 'Juli'
    } else if (monthName === 'August') {
      monthName = 'Agustus'
    } else if (monthName === 'September') {
      monthName = 'September'
    } else if (monthName === 'October') {
      monthName = 'Oktober'
    } else if (monthName === 'November') {
      monthName = 'November'
    } else if (monthName === 'December') {
      monthName = 'Desember'
    } else {
      monthName = ''
    }
  }

  const isAOS = useSelector<IRootState, boolean>(appSelector.isAOS, shallowEqual)
  const classNames = classnames({
    header__tit: isAOS,
    'header-tit__lv1': !isAOS,
  })
  const Title = () => (
    <h1 className={classNames}>
      <button type="button" className="header-tit__month" onClick={props.onClick}>
        {monthName}
      </button>
    </h1>
  )

  if (isAOS) {
    return (
      <div className="header--month header__ctr">
        <Title />
      </div>
    )
  }

  return <Title />
}
